var BusinessApplicationUtils = (function () {
  function getEndpointOrigin(endpoint) {
    try {
      return new URL(endpoint).origin;
    } catch (error) {
      return '';
    }
  }

  function isGoogleScriptOrigin(origin) {
    try {
      var url = new URL(origin);
      return url.protocol === 'https:'
        && (url.hostname === 'script.google.com'
          || url.hostname === 'script.googleusercontent.com'
          || url.hostname.endsWith('.script.googleusercontent.com'));
    } catch (error) {
      return false;
    }
  }

  function isMatchingResponse(event, requestId) {
    var data = event && event.data;
    return isGoogleScriptOrigin(event && event.origin)
      && data
      && data.source === 'md-business-application'
      && data.requestId === requestId;
  }

  function createRequestId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function normalizeOptionalAbn(value) {
    var abn = String(value || '').trim();
    return abn || 'Not provided';
  }

  return {
    createRequestId: createRequestId,
    getEndpointOrigin: getEndpointOrigin,
    isMatchingResponse: isMatchingResponse,
    normalizeOptionalAbn: normalizeOptionalAbn,
  };
})();

class BusinessAccountApplication extends HTMLElement {
  constructor() {
    super();
    this.activeRequestId = '';
    this.timeoutId = null;
    this.onSubmit = this.onSubmit.bind(this);
    this.onMessage = this.onMessage.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('[data-business-application-form]');
    if (!this.form) return;

    this.submitButton = this.form.querySelector('[type="submit"]');
    this.status = this.querySelector('[data-application-status]');
    this.requestIdInput = this.form.querySelector('[name="request_id"]');
    this.sourcePageInput = this.form.querySelector('[name="source_page"]');
    this.parentOriginInput = this.form.querySelector('[name="parent_origin"]');
    this.abnInput = this.form.querySelector('[name="abn"]');
    this.form.addEventListener('submit', this.onSubmit);
    window.addEventListener('message', this.onMessage);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    window.removeEventListener('message', this.onMessage);
    clearTimeout(this.timeoutId);
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.activeRequestId || !this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.activeRequestId = BusinessApplicationUtils.createRequestId();
    this.requestIdInput.value = this.activeRequestId;
    this.sourcePageInput.value = window.location.href;
    this.parentOriginInput.value = window.location.origin;
    if (this.abnInput) {
      this.abnInput.value = BusinessApplicationUtils.normalizeOptionalAbn(this.abnInput.value);
    }
    this.setBusy(true);
    this.setStatus(this.dataset.submittingMessage || 'Submitting your application...', false);

    this.timeoutId = setTimeout(() => {
      this.finishRequest(false, this.dataset.timeoutMessage || 'The request timed out. Please try again.');
    }, 20000);

    this.form.submit();
    var successMessage = this.dataset.successMessage
      || 'Your Business Account application has been submitted.';
    if (!successMessage.toLowerCase().includes('whatsapp')) {
      successMessage += ' Further questions? Contact us via WhatsApp.';
    }
    this.finishRequest(
      true,
      successMessage,
    );
  }

  onMessage(event) {
    if (!this.activeRequestId) return;
    if (!BusinessApplicationUtils.isMatchingResponse(event, this.activeRequestId)) return;

    this.finishRequest(Boolean(event.data.ok), event.data.message);
  }

  finishRequest(ok, message) {
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
    this.setBusy(false);
    this.setStatus(
      message || (ok ? this.dataset.successMessage : this.dataset.errorMessage),
      !ok,
    );

    if (ok) this.form.reset();
    this.activeRequestId = '';
  }

  setBusy(isBusy) {
    if (!this.submitButton) return;
    this.submitButton.disabled = isBusy;
    this.submitButton.setAttribute('aria-busy', String(isBusy));
  }

  setStatus(message, isError) {
    if (!this.status) return;
    this.status.textContent = message || '';
    this.status.classList.toggle('business-application__status--error', Boolean(isError));
    this.status.classList.toggle('business-application__status--success', Boolean(message) && !isError);
  }
}

if (!customElements.get('business-account-application')) {
  customElements.define('business-account-application', BusinessAccountApplication);
}
